import React from 'react';
import { BadgeMostSoldOutlineIcon } from '@domain-group/fe-co-icon';
import { ListingInfoPill } from '../listing-info-pill';
import * as styles from './agent-award-pill.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AgentAwardPill = _ref => {
  var label = _ref.label;
  return ___EmotionJSX(ListingInfoPill, {
    label: label,
    icon: ___EmotionJSX(BadgeMostSoldOutlineIcon, {
      css: styles.icon,
      size: "custom"
    }),
    ctaIcon: ___EmotionJSX(React.Fragment, null),
    css: styles.agentAwardPill
  });
};